const renewalsQueryKey = 'renewals' as const
export const renewalKeys = {
  list: [renewalsQueryKey, 'list'],
  detail: (id: string) => [renewalsQueryKey, 'detail', id],
  stats: (userId: string) => [renewalsQueryKey, 'stats', userId],
}
